import { fsDateUtils } from './fsDateUtils';

/**
 * Filter to format a date according to the settings
 */
/** @ngInject */
export function fsDateTimeNoLocalFilter($cookies, userService) {
    return htmlCode => fsDateUtils.toString(htmlCode, userService, $cookies,
            format => format,false);
}
